export const POST_NOTIFICATION_BADGES_COUNT = "unreadPostCount";
export const COMMENT_NOTIFICATION_BADGES_COUNT = "unreadCommentCount";
export const ACADEMIC_HONESTY_NOTIFICATION_BADGES_COUNT =
  "unreadAcademicHonestyCount";
export const ATTACHMENT_NOTIFICATION_BADGES_COUNT = "unreadAttachmentsCount";
export const REVIEW_NOTIFICATION_BADGES_COUNT = "unreadReviewCount";
export const FEEDBACK_NOTIFICATION_BADGES_COUNT = "unreadFeedbackCount";
export const OTHER_CHANGES_BADGES_COUNT =
  "totalUnreadCountsOfPortfolioProjects";
export const ANNOTATION_NOTIFICATION_BADGES_COUNT =
  "unreadAttachmentAnnotatedCount";
export const EXPERIENCE_NOTIFICATION_BADGES_COUNT = "newProjectCount";
export const INTERVIEW_NOTIFICATION_BADGES_COUNT = "interviewCount";
export const PENDING_APPROVAL_NOTIFICATION_BADGES_COUNT =
  "pendingApprovalCount";
export const PROJECT_TASKS_NOTIFICATION_BADGES_COUNT =
  "unreadProjectTasksCommentsCount";
export const PROJECT_PRESENTATION_NOTIFICATION_BADGES_COUNT =
  "unreadProjectPresentationCommentsCount";
export const PROJECT_EVIDENCE_NOTIFICATION_BADGES_COUNT =
  "unreadProjectEvidenceCommentCount";

export const NODE_NOTIFICATION_TYPE_MAP = {
  reflectionsSpace: POST_NOTIFICATION_BADGES_COUNT,
  reflectionsAndEvidences: POST_NOTIFICATION_BADGES_COUNT,
  processJournal: POST_NOTIFICATION_BADGES_COUNT,
  action: POST_NOTIFICATION_BADGES_COUNT,
  academicHonesty: ACADEMIC_HONESTY_NOTIFICATION_BADGES_COUNT,
  rppf: ACADEMIC_HONESTY_NOTIFICATION_BADGES_COUNT,
  reflection: ACADEMIC_HONESTY_NOTIFICATION_BADGES_COUNT,
  feedback: FEEDBACK_NOTIFICATION_BADGES_COUNT,
  report: ANNOTATION_NOTIFICATION_BADGES_COUNT,
  formalInterviews: INTERVIEW_NOTIFICATION_BADGES_COUNT,
  supervisor: PENDING_APPROVAL_NOTIFICATION_BADGES_COUNT,
  externalSupervisor: PENDING_APPROVAL_NOTIFICATION_BADGES_COUNT,
};

export const NODE_COMMENT_TYPE_NOTIFICATION_TYPE_MAP = {
  PROJECT_TASK: PROJECT_TASKS_NOTIFICATION_BADGES_COUNT,
  PROJECT_PRESENTATION: PROJECT_PRESENTATION_NOTIFICATION_BADGES_COUNT,
};
